import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import {UserVerificationService} from "../../services/user-verification.service";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-security-edit',
  templateUrl: `./security-edit.component.html`,
})
export class SecurityEditComponent implements OnInit {

  public isAdmin: boolean = false;
  public inputIsDisable = true;
  public inputIsHidden = false;
  public selectIsDisable = false;
  public selectIsHidden = true;
  public isAdminSubscription: Subscription;
  public allSecurityOptions: string[] = ['None', 'SSL'];
  public hasError = false;
  public initialValue = [{}];
  public errorMessage;

  private security:string;

  @Input() inputValue;
  @Input() virtId;
  @Output() onChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(private userVerificationService: UserVerificationService, private http: HttpClient) {
    this.isAdminSubscription = userVerificationService.message.subscribe(res => this.isAdmin = res);
  }

  inputOnClick() {
    this.inputIsDisable = false;
    this.hasError = false;
    this.inputIsHidden = true;
    this.selectIsDisable = true;
    this.selectIsHidden = false;
  }

  inputOnSave() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var url = '';
    var body: any = {};

    url = ApiEndpoints.UPDATE_SECURITY;
    body = {"virtId": this.virtId, "security": this.security};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.hasError = false;
          this.initialValue = [{}];
          this.inputValue = this.security;
        },
        error => {
          this.hasError = true;
          this.errorMessage = error._body;
        }
      );

    this.inputIsDisable = true;
    this.inputIsHidden = false;
    this.selectIsDisable = false;
    this.selectIsHidden = true;
  }

  inputOnCancel(inputCheck) {
    this.inputValue = this.security;
    this.inputIsDisable = true;
    this.inputIsHidden = false;
    this.selectIsDisable = false;
    this.selectIsHidden = true;
    this.hasError = false;
    this.initialValue = [{}];
  }

  selectedSecurity(value:any):void {
    this.hasError = false;
    this.security = value.split(",",1)[0];
    this.onChange.emit(this.security);
  }

  trimValue(event) {
    event.target.value = event.target.value.replace(/\s\s+/g, ' ');
  }

  ngOnInit() {
    $(document).ready(function () {

      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });

    });
    this.security = this.inputValue;
  }

  ngOnDestroy() {
    this.isAdminSubscription.unsubscribe();
  }

}
